import React from 'react';

const Contact = () => {
    return (
        <div style={{ backgroundColor: 'green', marginTop: '100px' ,color:'white',padding:'10px'}}>
            <h1>Contact</h1>
            <br />
            <h4>By Phone</h4>
            <small>(Monday to Friday, 9am to 6pm PST)</small>
            <p>North America Toll-Free:
                1-877-930-7483</p>
            <p>International:
                1-604-637-0780</p>
            
        </div>
    );
};

export default Contact;